import TWEEN from "@tweenjs/tween.js";
export default {
  data() {
    return {
      currentPage: 0,
      moving: false,
      opts: {},
      width: document.body.clientWidth,
      animateCtrl: [],
      init: false,
    };
  },
  mounted() {
    window.onresize = () => {
      this.width = document.body.clientWidth;
    };
    this.$on("increment", function (e) {
      this.currentPage = e;
      this.animateCtrl.splice(e, 1, true);
    });
    this.$on("resize", function (e) {
      this.width = document.body.clientWidth;
    });
    this.animate();
    this.init = true;
  },
  computed: {
    height() {
      if (this.width >= 720 && window.innerHeight > (this.width / 16) * 9) {
        return (this.width / 16) * 9 + "px";
      } else {
        return window.innerHeight + "px";
      }
    },
  },
  methods: {
    animate(time) {
      requestAnimationFrame(this.animate);
      try {
        TWEEN.update(time);
      } catch (error) {}
    },
    turnTo(pageNum, height) {
      var _this = this;
      if (!this.$refs.fullpage) return;
      if (height) {
        this.$refs.iteam.scrollTo(
          this.$refs.iteam.scrollLeft,
          47.194 * parseFloat(window.document.documentElement.style.fontSize)
        );
      }
      this.animateCtrl.splice(pageNum, 1, true);
      // this.currentPage = pageNum;
      new TWEEN.Tween({
        height: this.$refs.fullpage.style.transform
          ? +this.$refs.fullpage.style.transform.match(
              /translate3d\(0px, (.*)px, 0px\)/
            )[1]
          : 0,
      })
        .easing(TWEEN.Easing.Quadratic.Out)
        .to(
          {
            height: -this.currentPage * parseFloat(this.height),
          },
          500
        )
        .onUpdate(function () {
          _this.$refs.fullpage.style.transform = `translate3d(0px, ${this.height}px, 0px)`;
        })
        .onComplete(() => {
          this.currentPage = pageNum;
          window.setTimeout(() => {
            this.moving = false;
          }, 700);
        })
        .start();
    },
    mousewheel(e) {
      if (this.moving) {
        return;
      }
      if (e.deltaY > 0 && this.currentPage < this.totalPage) {
        this.currentPage++;
        this.moving = true;
      } else if (e.deltaY < 0 && this.currentPage > 0) {
        this.currentPage--;
        this.moving = true;
      }
      this.turnTo(this.currentPage);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixin/fanpage.js